import type { GetProfileResData, LoginResData, RefreshResData } from '~/types/auth'
import type { DefaultApiResponse } from '~/types/default'

import { api, publicApi } from './api'

const doLogin = async (token: string): Promise<LoginResData> => {
  const response = await publicApi.post<LoginResData>(`/login/${token}`)

  return response.data
}

const doLogout = async (): Promise<DefaultApiResponse> => {
  const response = await api.post<DefaultApiResponse>('/logout')

  return response.data
}

const doRefresh = async (): Promise<RefreshResData> => {
  const response = await api.get<RefreshResData>('/refresh-token')

  return response.data
}

const getProfile = async (): Promise<GetProfileResData> => {
  const response = await api.get<GetProfileResData>('/me')

  return response.data
}

export default { doLogin, doLogout, doRefresh, getProfile }
